/** Recipes and revisions (docs/contracts/persistence.md). */
/** Schema version of persisted documents (revisions, backups). */
export const DOCUMENT_SCHEMA_VERSION = 1;
/**
 * The variant shown for a family: the pinned member, otherwise the most recently updated one
 * (ties: smallest id). Members in the trash never count.
 */
export const defaultVariant = (family, recipes) => {
    const members = recipes.filter((r) => r.familyId === family.id && r.trashedAt === undefined);
    const pinned = members.find((r) => r.id === family.pinnedRecipeId);
    if (pinned)
        return pinned;
    return [...members].sort((a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt) || (a.id < b.id ? -1 : 1))[0];
};
//# sourceMappingURL=types.js.map